import { useEffect, useRef } from 'react';

/**
 * 선화 위에 눈동자 2개를 얹고, trackRef 영역의 마우스 위치를 따라 움직인다.
 * 리렌더를 피하려고 state 대신 ref 로 style 을 직접 바꾼다.
 */
export default function Character({ trackRef }) {
  const charRef = useRef(null);
  const pupilsRef = useRef([]);

  useEffect(() => {
    const track = trackRef && trackRef.current;
    const char = charRef.current;
    if (!track || !char) return undefined;

    // 모션을 줄이기로 한 사용자는 눈동자도 고정한다
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce.matches) return undefined;

    const setPupils = (x, y) => {
      pupilsRef.current.forEach((p) => {
        if (p) p.style.transform = `translate(${x}px, ${y}px)`;
      });
    };

    const onMove = (e) => {
      const r = char.getBoundingClientRect();
      const dx = e.clientX - (r.left + r.width * 0.49);
      const dy = e.clientY - (r.top + r.height * 0.49);
      const dist = Math.max(1, Math.hypot(dx, dy));
      const max = r.width * 0.012;
      const k = Math.min(1, dist / 260);
      setPupils((dx / dist) * max * k, (dy / dist) * max * k);
    };
    const onLeave = () => setPupils(0, 0);

    track.addEventListener('mousemove', onMove);
    track.addEventListener('mouseleave', onLeave);
    return () => {
      track.removeEventListener('mousemove', onMove);
      track.removeEventListener('mouseleave', onLeave);
    };
  }, [trackRef]);

  return (
    <div className="lw-char" ref={charRef}>
      <img
        className="lw-char-img"
        src="/images/jieun-noeyes.png"
        alt="후드티를 입은 단발머리 곽지은 캐릭터"
        width="800"
        height="800"
        decoding="async"
      />

      {['left', 'right'].map((side, i) => (
        <div className={`lw-eye lw-eye--${side}`} key={side} aria-hidden="true">
          <div
            className="lw-pupil"
            ref={(el) => { pupilsRef.current[i] = el; }}
          >
            <div className="lw-eye-inner" />
          </div>
        </div>
      ))}

      <div className="lw-bubble">오늘도 작은 승리 하나</div>
    </div>
  );
}
